import { call, put } from 'redux-saga/effects';
import { getParamApplicationId, getParamBrandHash } from '@corefront/redux-aba';
import { getGrowthBook } from '../../../services/growthbook';
import FEATURES from '../../../constants/featureToggling';

export function* abaExtraDataWatcher() {
  const growthbook = yield call(getGrowthBook);
  const isLatestsABARequestsEnabled = growthbook.isOn(
    FEATURES.ENABLE_LATESTS_ABA_REQUESTS
  );

  if (isLatestsABARequestsEnabled) {
    yield put(getParamBrandHash());
    yield put(getParamApplicationId());
  }
}
